<button
  (click)="deleteRowAtIndex.emit(rowIndex)"
  appTooltip="Zeile löschen"
  position="left"
  class="bg-danger invisible flex h-[26px] w-[26px] items-center justify-center rounded-md group-hover:visible">
  <span class="material-icons" [ngStyle]="{ color: 'white' }">close</span>
</button>
<div
  class="addRowOverlay group/add-button -top-2"
  (dblclick)="rowAdded.emit({ index: rowIndex, row: row })">
  <div class="addRowLine"></div>
  <button
    class="addRowButton"
    pTooltip="Zeile einfügen"
    (click)="rowAdded.emit({ index: rowIndex, row: row })">
    <span class="material-icons" [ngStyle]="{ color: 'white' }">add</span>
  </button>
</div>
@if (topAndBottomAddLineControls) {
  <div
    class="addRowOverlay group/add-button -bottom-2"
    (dblclick)="rowAdded.emit({ index: rowIndex + 1, row: row })">
    <div class="addRowLine"></div>
    <button
      class="addRowButton"
      pTooltip="Zeile einfügen"
      (click)="rowAdded.emit({ index: rowIndex + 1, row: row })">
      <span class="material-icons" [ngStyle]="{ color: 'white' }">add</span>
    </button>
  </div>
}
